import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { handlePhoneChange, handleNameChange, handlePostalChange, handleZipChange, handleMessageChange, handleSubmit } from '../../utils/formHandlers';
import { fetchCountryFromIP } from '../../utils/fetchCountryFromIP';
import { FaArrowRight } from 'react-icons/fa';
import { MdLocalPhone } from "react-icons/md";

function HeroForm({ cityData, locationInfo }) {
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [zip, setZip] = useState('');
    const [message, setMessage] = useState('');
    const [country, setCountry] = useState('');
    
    // Validation error states
    const [errors, setErrors] = useState({});

    useEffect(() => {
        fetchCountryFromIP().then(ipData => {
            if (ipData) {
                setCountry(ipData.country_name);
            }
        });
    }, []);

    const validateForm = () => {
        const newErrors = {};
        
        if (!name) {
            newErrors.name = "Name is required";
        }
        
        // Remove non-digit characters before checking phone number validity
        const cleanedPhone = phone.replace(/\D/g, '');
    
        if (!cleanedPhone || cleanedPhone.length < 10) {
            newErrors.phone = "Phone number must be at least 10 digits";
        }
    
        if (!message) {
            newErrors.message = "Message is required";
        }
        
        return newErrors;
    };
    

    const formSubmitHandler = (event) => {
        event.preventDefault();
        const formState = { name, phone, postalCode, zip, message };
        const formErrors = validateForm();

        if (Object.keys(formErrors).length === 0) {
            handleSubmit(formState, cityData, 
                () => {
                    navigate('/thankyou');
                }, 
                (error) => {
                    console.error("Error adding lead: ", error);
                }
            );
        } else {
            setErrors(formErrors);  // Set validation errors
        }
    };

    return (
        <form 
            onSubmit={formSubmitHandler} 
            className="main-slider__form comment-form-2-validated" 
            noValidate="noValidate"
        >
            <div className="row">
                <div className="col-xl-12">
                    <div className="main-slider__form-input-box">
                        <input 
                            type="text" 
                            placeholder="Name:" 
                            name="name" 
                            value={name}
                            autoComplete="name"
                            onChange={(e) => handleNameChange(setName, e)}
                            maxLength={20}
                            required
                        />
                        {errors.name && <span className="error-text">{errors.name}</span>}
                    </div>
                </div>
                <div className="col-xl-12">
                    <div className="main-slider__form-input-box">
                        <input 
                            type="text" 
                            placeholder="Phone:" 
                            name="phone" 
                            autoComplete="tel"
                            value={phone}
                            onChange={(e) => handlePhoneChange(setPhone, e)}
                            maxLength={12}
                            required
                        />
                        {errors.phone && <span className="error-text">{errors.phone}</span>}
                    </div>
                </div>
                {!cityData.locationId && (
                <div className="col-xl-12">
                    <div className="main-slider__form-input-box">
                        {country === 'Canada' && (
                        <input 
                            type="text" 
                            placeholder="Postal code:" 
                            name="postalCode" 
                            autoComplete="postal-code"
                            value={postalCode.toUpperCase()}
                            onChange={(e) => handlePostalChange(setPostalCode, e)}
                            maxLength={6}
                            required
                        />
                        )}
                        {country === 'United States' && (
                        <input 
                            type="text" 
                            placeholder="Zip code:" 
                            name="zip" 
                            autoComplete="postal-code"
                            value={zip}
                            onChange={(e) => handleZipChange(setZip, e)}
                            maxLength={5}
                            required
                        />
                        )}
                        {errors.zip && <span className="error-text">{errors.zip}</span>}
                        {errors.postalCode && <span className="error-text">{errors.postalCode}</span>}
                    </div>
                </div>
                )}
            </div>
            <div className="row">
                <div className="col-xl-12">
                    <div className="main-slider__form-input-box text-message-box">
                        <textarea 
                            name="message" 
                            placeholder="What do you want us to remove?" 
                            value={message} 
                            autoComplete="off"
                            onChange={(e) => handleMessageChange(setMessage, e)}
                            required
                            style={{
                                resize: 'none', // Prevent resizing of the textarea
                            }}
                        />
                        {errors.message && <span className="error-text">{errors.message}</span>}
                    </div>
                    <div className="main-slider__form-btn-box">
                        <button 
                            type="submit" 
                            className="thm-btn main-slider__form-btn"
                            style={{
                                fontSize: '1.1rem',
                                background: 'black',
                                border: '6px solid yellow',
                            }}
                        >
                            Get Your Free Quote
                            &nbsp;
                            <FaArrowRight />
                        </button>
                    </div>
                </div>
                <hr 
                    style={{
                        width: '100%',
                        marginTop: '20px',
                    }}
                />
                <p
                    style={{
                        marginTop: '-20px',
                        fontFamily: "Roboto, sans-serif",
                        fontSize: '1.2rem',
                        lineHeight: '1.3em',
                    }}
                >
                    <br />
                    <span
                        style={{
                            fontSize: '1.5rem',
                            marginRight: '10px',
                        }}
                    >
                        <MdLocalPhone />
                    </span>
                    Call anytime {locationInfo.tracking_phone} 
                </p>
            </div>
        </form>
    );
}

export default HeroForm;
